export const SLICE_CONFIG = [
  { key: "yet_to_start",          label: "Yet to Start",          color: "#9ca3af", hoverColor: "#6b7280" },
  { key: "data_collection",       label: "Data Collection",       color: "#60a5fa", hoverColor: "#3b82f6" },
  { key: "hand_holding_required", label: "Hand-Holding Needed",   color: "#fbbf24", hoverColor: "#f59e0b" },
  { key: "completed_households",  label: "Completed",             color: "#34d399", hoverColor: "#10b981" },
  { key: "closed",                label: "Did Not Move",          color: "#f87171", hoverColor: "#ef4444" },
];

export const HOUSEHOLD_METRICS_SLICE_CONFIG = [
  { key: "yet_to_start",          label: "Yet to Start",          color: "#9ca3af", hoverColor: "#6b7280" },
  { key: "data_collection",       label: "Data Collection",       color: "#60a5fa", hoverColor: "#3b82f6" },
  { key: "hand_holding_required", label: "Hand-Holding Required", color: "#fbbf24", hoverColor: "#f59e0b" },
  { key: "re_papering",           label: "Re-papering",           color: "#fb923c", hoverColor: "#f97316" },
  { key: "completed",             label: "Completed",             color: "#34d399", hoverColor: "#10b981" },
  { key: "closed",                label: "Closed",                color: "#f87171", hoverColor: "#ef4444" },
];

export const TRANSITION_HEALTH_SLICE_CONFIG = [
  { key: "in_progress",           label: "In Progress",           color: "#60a5fa", hoverColor: "#3b82f6" },
  { key: "pending_on_advisor",    label: "Pending on Advisor",    color: "#fb923c", hoverColor: "#f97316" },
  { key: "stale_household",       label: "Critical Pending",      color: "#f87171", hoverColor: "#ef4444" },
  { key: "hand_holding_required", label: "Hand-Holding Required", color: "#fbbf24", hoverColor: "#f59e0b" },
];

export const ACCOUNT_METRICS_SLICE_CONFIG = [
  { key: "needs_transition",  label: "Needs Transition",  color: "#60a5fa", hoverColor: "#3b82f6" },
  { key: "not_transitioning", label: "Not Transitioning", color: "#9ca3af", hoverColor: "#6b7280" },
];

export const TRANSITION_STAGE_STYLES = {
  created:                { parent: "bg-indigo-300",  child: "bg-indigo-200" },
  active_data_collection: { parent: "bg-indigo-500",  child: "bg-indigo-300" },
  data_complete:          { parent: "bg-slate-600",   child: "bg-slate-400"  },
  forms_generated:        { parent: "bg-amber-300",   child: "bg-amber-200"  },
  signature_execution:    { parent: "bg-amber-500",   child: "bg-amber-300"  },
  custodian_flow:         { parent: "bg-amber-800",   child: "bg-amber-600"  },
  firm_paperwork:         { parent: "bg-violet-500",  child: "bg-violet-300" },
  query_raised:           { parent: "bg-yellow-400",  child: "bg-yellow-300" },
  hh_completed:           { parent: "bg-emerald-700", child: "bg-emerald-500" },
};

export const TRANSITION_BREAKDOWN_OVERRIDES = {
  nigo: "bg-red-400",
};

export const DEFAULT_GROUP_STYLE = { parent: "bg-gray-400", child: "bg-gray-300" };
